import { devices } from '../../util/devices';
import { DocksMap } from '../ConnectionsPanels/types';

export const getActionDevice = (
  dockNumber,
  deviceNumber,
  roomsDocks: DocksMap[] | any
) => {
  const docks: any[] = (Object.values(roomsDocks) as any[]).flat();

  return docks
    .find(dock => dock.number === dockNumber)
    .devices // eslint-disable-next-line @typescript-eslint/no-unused-vars-experimental
    .find((_device, index) => index === deviceNumber);
};

export const outputDevicesFilterFunction = ({ symbol, actions }) =>
  symbol !== devices.smokeDetector.symbol && Object.values(actions).length;

export default {
  getActionDevice,
  outputDevicesFilterFunction
};
